/**
 * Testimonial video carousel: Swiper setup, video lightbox and quote alignment.
 * Was a 14KB inline <script> repeated by every sections/testimonial-video.liquid
 * instance; moved here so it is cached across pages and parsed off the critical
 * path (deferred). The autoplay setting now comes from data-auto-play on the
 * section wrapper.
 */
  (function () {
    // One copy per page is enough: each section instance emits the same deferred
    // <script src>, and every tag executes, so the second and later ones bail.
    if (window.__testimonialVideoInit) return;
    window.__testimonialVideoInit = true;

    // Per-section setting, read from the wrapper (was a Liquid value inlined per section).
    function autoPlayFor(sectionId) {
      var el = document.querySelector('[data-section-id="' + sectionId + '"]');
      return !!el && el.getAttribute('data-auto-play') === 'true';
    }
    var testimonialSwipers = {};
    var lightbox = null;         // shared lightbox element (built once)
    var activeSectionId = null;  // section whose video is open in the lightbox
    var lastFocused = null;      // element focus returns to when the lightbox closes

    function initTestimonialsSwiper(sectionId) {
      // Destroy existing swiper if it exists
      if (testimonialSwipers[sectionId]) {
        testimonialSwipers[sectionId].destroy(true, true);
      }

      var isMobile = window.matchMedia("(max-width: 767px)").matches;

      var swiperOptions = {
        loop: true,
        slidesPerView: 1.32,
        spaceBetween: 24,
        centeredSlides: true,

        // The dots sit in their own row under the carousel and the arrows sit
        // beside it, so neither resolves against the swiper element any more.
        pagination: {
          el: '#testimonials-controls-' + sectionId + ' .swiper-pagination',
          clickable: true,
        },

        navigation: {
          prevEl: '#testimonials-slider-' + sectionId + ' .testimonials-nav--prev',
          nextEl: '#testimonials-slider-' + sectionId + ' .testimonials-nav--next',
        },

        breakpoints: {
          600: {
            loop: false,
            slidesPerView: 2.2,
            spaceBetween: 24,
            centeredSlides: false,
          },
          900: {
            loop: false,
            slidesPerView: 3,
            spaceBetween: 24,
            centeredSlides: false,
          },
          1100: {
            loop: false,
            slidesPerView: 4,
            spaceBetween: 24,
            centeredSlides: false,
          },
        },
      };

      // Enable autoplay only on mobile if the setting is enabled
      if (isMobile && autoPlayFor(sectionId)) {
        swiperOptions.autoplay = {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        };
      }

      testimonialSwipers[sectionId] = new Swiper(
        '#testimonials-swiper-' + sectionId,
        swiperOptions
      );

      // If this section's video is open in the lightbox (e.g. after a resize
      // re-init), keep the carousel paused instead of letting it resume.
      // Same after a shopper's pause (carousel-pause-button).
      if (activeSectionId === sectionId || testimonialSwipers[sectionId].el.dataset.userPaused === 'true') {
        stopSwiperAutoplay(sectionId);
      }

      alignSectionCards(sectionId);
    }

    /*
      Quotes run to a different number of lines per card, so the reviewer name
      (and the verified badge under it) lands at a different height in every
      slide. Measuring the tallest quote in the carousel and giving all of them
      that height as a floor puts the names back on one line. It is done in JS
      rather than CSS because the line count depends on the rendered width of
      the slide, which changes at every breakpoint.
    */
    function alignQuotes(swiperEl) {
      if (!swiperEl) return;

      var quotes = swiperEl.querySelectorAll('.testimonial-card__quote');
      if (!quotes.length) return;

      // Release last run's floor first, otherwise we would only ever measure
      // the previous (possibly larger) height and never shrink back down.
      for (var i = 0; i < quotes.length; i++) {
        quotes[i].style.minHeight = '';
      }

      var tallest = 0;

      for (var j = 0; j < quotes.length; j++) {
        var height = quotes[j].getBoundingClientRect().height;
        if (height > tallest) tallest = height;
      }

      if (!tallest) return;

      for (var k = 0; k < quotes.length; k++) {
        quotes[k].style.minHeight = tallest + 'px';
      }
    }

    function alignSectionCards(sectionId) {
      var swiperEl = document.querySelector('#testimonials-swiper-' + sectionId);
      if (!swiperEl) return;

      alignQuotes(swiperEl);

      var swiper = testimonialSwipers[sectionId];
      if (swiper && !swiper.destroyed) swiper.update();
    }

    function alignAllSections() {
      document.querySelectorAll('[data-section-id]').forEach(function (section) {
        var id = section.getAttribute('data-section-id');
        if (document.querySelector('#testimonials-swiper-' + id)) {
          alignSectionCards(id);
        }
      });
    }

    /*
      Watch the carousel box itself, not just the window: the slide width also
      changes when a parent resizes (drawer opens, theme editor panel, zoom),
      and those never fire a window resize.
    */
    function observeSectionWidth(sectionId) {
      if (typeof ResizeObserver === 'undefined') return;

      var swiperEl = document.querySelector('#testimonials-swiper-' + sectionId);
      if (!swiperEl || swiperEl.dataset.alignObserved === 'true') return;

      swiperEl.dataset.alignObserved = 'true';

      var frame = null;

      new ResizeObserver(function () {
        // Coalesce to one measurement per frame; the observer fires once per
        // element and we would otherwise re-measure for every slide.
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          frame = null;
          alignQuotes(swiperEl);
        });
      }).observe(swiperEl);
    }

    function stopSwiperAutoplay(sectionId) {
      var swiper = testimonialSwipers[sectionId];
      if (swiper && swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    }

    function startSwiperAutoplay(sectionId) {
      var swiper = testimonialSwipers[sectionId];
      if (swiper && swiper.autoplay && !swiper.autoplay.running && swiper.el.dataset.userPaused !== 'true') {
        swiper.autoplay.start();
      }
    }

    function buildLightbox() {
      if (lightbox) return lightbox;

      lightbox = document.createElement('div');
      lightbox.className = 'testimonial-lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.setAttribute('aria-label', 'Testimonial video');
      lightbox.innerHTML =
        '<div class="testimonial-lightbox__backdrop" data-close></div>' +
        '<div class="testimonial-lightbox__dialog">' +
          '<button type="button" class="testimonial-lightbox__close" aria-label="Close video" data-close>' +
            '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
              '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
            '</svg>' +
          '</button>' +
          '<div class="testimonial-lightbox__video-wrap"></div>' +
        '</div>';

      document.body.appendChild(lightbox);

      lightbox.addEventListener('click', function (e) {
        if (e.target.closest('[data-close]')) closeLightbox();
      });

      return lightbox;
    }

    function onLightboxKeydown(e) {
      if (e.key === 'Escape') {
        closeLightbox();
        return;
      }

      if (e.key === 'Tab') {
        // Keep focus within the dialog while it is open
        var focusables = lightbox.querySelectorAll(
          'button, video, [href], [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;

        var first = focusables[0];
        var last = focusables[focusables.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function openLightbox(sectionId, sourceVideo, launcher) {
      buildLightbox();

      var wrap = lightbox.querySelector('.testimonial-lightbox__video-wrap');
      wrap.innerHTML = '';

      // Clone the card's video (with its sources) and show it full / uncropped
      var clone = sourceVideo.cloneNode(true);
      clone.classList.remove('testimonial-card__video');
      clone.removeAttribute('muted');
      clone.muted = false;
      clone.controls = true;
      clone.setAttribute('playsinline', '');
      clone.setAttribute('preload', 'auto');
      // Cards with their own cover image skip the poster attribute (it is
      // fetched eagerly); the lightbox copy still gets one while it loads.
      if (!clone.getAttribute('poster') && sourceVideo.dataset.poster) {
        clone.setAttribute('poster', sourceVideo.dataset.poster);
      }

      // Open at the video's real shape (no wide-rectangle flash before load).
      // Use the known ratio from Liquid, then refine once metadata loads.
      var aspect = sourceVideo.getAttribute('data-aspect');
      if (aspect) clone.style.aspectRatio = aspect;
      clone.addEventListener('loadedmetadata', function () {
        if (clone.videoWidth && clone.videoHeight) {
          clone.style.aspectRatio = clone.videoWidth + ' / ' + clone.videoHeight;
        }
      });

      wrap.appendChild(clone);

      activeSectionId = sectionId;
      lastFocused = launcher || document.activeElement;

      lightbox.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onLightboxKeydown);

      // Keep the carousel still while the video is open
      stopSwiperAutoplay(sectionId);

      var playPromise = clone.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});

      var closeBtn = lightbox.querySelector('.testimonial-lightbox__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      if (!lightbox || !lightbox.classList.contains('is-open')) return;

      var wrap = lightbox.querySelector('.testimonial-lightbox__video-wrap');
      var vid = wrap.querySelector('video');
      if (vid) vid.pause();
      wrap.innerHTML = '';

      lightbox.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onLightboxKeydown);

      // Resume the carousel now that the video is closed
      if (activeSectionId) startSwiperAutoplay(activeSectionId);
      activeSectionId = null;

      if (lastFocused && lastFocused.focus) lastFocused.focus();
      lastFocused = null;
    }

    function initVideoCards(sectionEl) {
      var sectionId = sectionEl.getAttribute('data-section-id');
      if (!sectionId) {
        var idEl = sectionEl.querySelector('[data-section-id]');
        if (idEl) sectionId = idEl.getAttribute('data-section-id');
      }

      var cards = sectionEl.querySelectorAll('[data-video-card]');

      cards.forEach(function (card) {
        var video = card.querySelector('.testimonial-card__video');
        if (!video) return;

        // Avoid stacking duplicate listeners if the section re-initializes
        if (card.dataset.testimonialBound) return;
        card.dataset.testimonialBound = '1';

        // Open the video full / uncropped in the lightbox
        card.addEventListener('click', function () {
          openLightbox(sectionId, video, card);
        });

        // Keyboard support (the card is role="button" tabindex="0")
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            openLightbox(sectionId, video, card);
          }
        });
      });
    }

    function whenSwiperReady(fn) {
      if (typeof window.ensureSwiper === 'function') {
        window.ensureSwiper(fn);
      } else {
        fn();
      }
    }

    function initAllSections() {
      var sections = document.querySelectorAll('[data-section-id]');

      sections.forEach(function (section) {
        var id = section.getAttribute('data-section-id');

        if (document.querySelector('#testimonials-swiper-' + id)) {
          initTestimonialsSwiper(id);
          initVideoCards(section);
          observeSectionWidth(id);
        }
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      whenSwiperReady(initAllSections);
    });

    document.addEventListener('swiper:ready', initAllSections);

    // Webfonts swap in after first paint and change how many lines a quote
    // takes, so the first measurement has to be redone once they are ready.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(alignAllSections);
    }

    window.addEventListener('load', alignAllSections);

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target;
      var id = section.querySelector('[data-section-id]');

      if (!id) return;

      id = id.getAttribute('data-section-id');

      if (document.querySelector('#testimonials-swiper-' + id)) {
        initTestimonialsSwiper(id);
        initVideoCards(section);
        observeSectionWidth(id);
      }
    });

    // Reinitialize Swiper only when crossing the mobile/desktop boundary.
    // (Mobile browsers fire resize constantly as the address bar shows/hides;
    // re-initing on every one of those would restart autoplay mid-playback.)
    var resizeTimeout;
    var lastIsMobile = window.matchMedia("(max-width: 767px)").matches;

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);

      resizeTimeout = setTimeout(function () {
        // Slide widths change on every resize, so the quotes are re-measured
        // each time even when the carousel itself does not need re-initing.
        alignAllSections();

        var nowIsMobile = window.matchMedia("(max-width: 767px)").matches;
        if (nowIsMobile === lastIsMobile) return;
        lastIsMobile = nowIsMobile;

        document.querySelectorAll('[data-section-id]').forEach(function (section) {
          var id = section.getAttribute('data-section-id');

          if (document.querySelector('#testimonials-swiper-' + id)) {
            initTestimonialsSwiper(id);
          }
        });
      }, 200);
    });
  })();
